<template>
  <div class="fromStyle thirdPartyContainer">
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item label="类型" v-bind="formItemLayout">
        <a-radio-group v-model="type">
          <a-radio :value="1"> 公司</a-radio>
          <a-radio :value="2"> 个人 </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="联系人姓名" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'contact_name',
            { rules: [{ required: true, message: '请填写联系人姓名!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item label="联系人电话" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'contact_phone',
            { rules: [{ required: true, message: '请填写联系人电话!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item v-if="type == 1" label="公司名称" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'name',
            { rules: [{ required: true, message: '请填写公司名称!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item v-if="type == 1" label="公司地址" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'company_address',
            { rules: [{ required: true, message: '请填写公司地址!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item
        v-if="type == 1"
        label="纳税人识别号"
        v-bind="formItemLayout"
      >
        <a-input
          v-decorator="[
            'taxpayer',
            { rules: [{ required: true, message: '请填写公司地址!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item v-if="type == 2" label="身份证号码" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'idcard',
            { rules: [{ required: true, message: '请填写身份证号码!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item label="银行名称" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'bank_name',
            { rules: [{ required: true, message: '请填写银行名称!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item label="支行名称" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'bank_branch',
            { rules: [{ required: true, message: '请填写支行名称!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item label="银行账号" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'bank_no',
            { rules: [{ required: true, message: '请填写银行账号!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item label="是否正式签约" v-bind="formItemLayout">
        <a-radio-group
          v-decorator="[
            'sign_status',
            { rules: [{ required: true, message: '请选择是否正式签约!' }] }
          ]"
        >
          <a-radio :value="2"> 是</a-radio>
          <a-radio :value="1"> 否 </a-radio>
        </a-radio-group>
      </a-form-item>
      <!-- <a-form-item label="结算类型" v-bind="formItemLayout">
        <a-radio-group
          v-decorator="[
            'settlement_type',
            { rules: [{ required: true, message: '请选择结算类型!' }] },
          ]"
        >
          <a-radio value="1">一次性买断</a-radio>
          <a-radio value="2">按月支付</a-radio>
        </a-radio-group>
      </a-form-item> -->
      <a-form-item label="上级项目" v-bind="formItemLayout">
        <a-select
          showSearch
          :filterOption="filterOption"
          v-model="selectedOneVal"
          @change="selectedOne"
          placeholder="请选择项目"
          style="width: 160px; margin-right: 10px"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, i) in proListOne"
            :key="i"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
        <a-select
          @change="selectedTwo"
          v-model="selectedTwoVal"
          showSearch
          :filterOption="filterOption"
          placeholder="请选择项目"
          style="width: 160px"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, i) in proListTwo"
            :key="i"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="合作项目" v-bind="formItemLayout">
        <a-select
          :maxTagCount="10"
          mode="multiple"
          style="width: 80%; margin-right: 10px"
          v-model="project_list"
          showSearch
          :filterOption="filterOption"
          placeholder="请选择项目"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, i) in proListThree"
            :key="i"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
        <span>
          <a-checkbox :checked="checked" @change="selectedAll">全选</a-checkbox>
        </span>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button style="margin-right: 20px" @click="onReset">重置</a-button>
        <a-button type="primary" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  inject: ["reload"],
  data() {
    return {
      typeList: [
        {
          label: "公司内部",
          value: 1
        },
        {
          label: "员工",
          value: 2
        },
        {
          label: "客户",
          value: 3
        }
      ],
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 12 }
      },
      businessList: [],
      type: 1,
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      selectedOneVal: "",
      selectedTwoVal: "",
      project_list: [],
      checked: false
    };
  },
  mounted() {
    this.getBusiness(); //获取项目列表
    this.getProOne(); //一级项目
    if (this.editDetail != undefined) {
      this.getDetails();
    }
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.getDetails();
    },
    type() {
      let ids = [];
      if (
        this.editDetail.project_ids != undefined &&
        this.editDetail.project_ids != ""
      ) {
        ids = this.editDetail.project_ids.split(",").map(Number);
      }
      this.project_list = ids;
      // console.log(this.project_list.length)
      this.form = this.$form.createForm(this, {
        onFieldsChange: (_, changedFields) => {
          this.$emit("change", changedFields);
        },
        mapPropsToFields: () => {
          return {
            name: this.$form.createFormField({
              ...this.name,
              value: this.editDetail.name
            }),
            bank_name: this.$form.createFormField({
              ...this.bank_name,
              value: this.editDetail.bank_name
            }),
            contact_name: this.$form.createFormField({
              ...this.contact_name,
              value: this.editDetail.contact_name
            }),
            contact_phone: this.$form.createFormField({
              ...this.contact_phone,
              value: this.editDetail.contact_phone
            }),
            company_address: this.$form.createFormField({
              ...this.company_address,
              value: this.editDetail.company_address
            }),
            taxpayer: this.$form.createFormField({
              ...this.taxpayer,
              value: this.editDetail.taxpayer
            }),
            bank_branch: this.$form.createFormField({
              ...this.bank_branch,
              value: this.editDetail.bank_branch
            }),
            bank_no: this.$form.createFormField({
              ...this.bank_no,
              value: this.editDetail.bank_no
            }),
            idcard: this.$form.createFormField({
              ...this.idcard,
              value: this.editDetail.idcard
            }),
            sign_status: this.$form.createFormField({
              ...this.sign_status,
              value: this.editDetail.sign_status
            })
          };
        },
        onValuesChange(_, values) {}
      });
    }
  },
  methods: {
    getDetails() {
      // this.getBusiness(); //获取项目列表
      let ids = [];
      if (
        this.editDetail.project_ids != undefined &&
        this.editDetail.project_ids != ""
      ) {
        ids = this.editDetail.project_ids.split(",").map(Number);
      }
      this.project_list = ids;
      // console.log(this.project_list.length)
      this.type = this.editDetail.type;
      this.form = this.$form.createForm(this, {
        onFieldsChange: (_, changedFields) => {
          this.$emit("change", changedFields);
        },
        mapPropsToFields: () => {
          return {
            name: this.$form.createFormField({
              ...this.name,
              value: this.editDetail.name
            }),
            bank_name: this.$form.createFormField({
              ...this.bank_name,
              value: this.editDetail.bank_name
            }),
            contact_name: this.$form.createFormField({
              ...this.contact_name,
              value: this.editDetail.contact_name
            }),
            contact_phone: this.$form.createFormField({
              ...this.contact_phone,
              value: this.editDetail.contact_phone
            }),
            company_address: this.$form.createFormField({
              ...this.company_address,
              value: this.editDetail.company_address
            }),
            taxpayer: this.$form.createFormField({
              ...this.taxpayer,
              value: this.editDetail.taxpayer
            }),
            bank_branch: this.$form.createFormField({
              ...this.bank_branch,
              value: this.editDetail.bank_branch
            }),
            bank_no: this.$form.createFormField({
              ...this.bank_no,
              value: this.editDetail.bank_no
            }),
            idcard: this.$form.createFormField({
              ...this.idcard,
              value: this.editDetail.idcard
            }),
            sign_status: this.$form.createFormField({
              ...this.sign_status,
              value: this.editDetail.sign_status
            })
          };
        },
        onValuesChange(_, values) {}
      });
    },
    onReset() {
      this.form.resetFields();
      this.selectedOneVal = "";
      this.selectedTwoVal = "";
      this.proListTwo = [];
      this.proListThree = [];
      this.project_list = [];
      this.getProOne();
      this.getBusiness(); //获取项目列表
    },
    selectedAll(e) {
      this.checked = e.target.checked;
      if (this.selectedOneVal == "") {
        this.project_list = [];
      }
      if (e.target.checked) {
        this.proListThree.forEach(element => {
          if (this.project_list.indexOf(element.id) == -1) {
            // console.log(element.id)
            this.project_list.push(element.id);
          }
          // console.log(element)
        });
      } else {
        this.project_list = [];
      }
      this.getBusiness(); //获取项目列表
    },

    selectedOne(id) {
      this.checked = false;
      this.isShowTwo = true;
      this.selectedTwoVal = "";
      this.getProID(id, 1); //获取下级项目
      this.getThreePro(id);
      // console.log(id);
    },
    selectedTwo(id) {
      this.checked = false;
      this.isShowThree = true;
      this.getProID(id, 2); //获取下级项目
    },
    getThreePro(id) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByProjectTop";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            // console.log(this.proListThree);
          }
        });
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListOne = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            if (level == 1) {
              this.proListTwo = res.data.data;
            } else if (level == 2) {
              this.proListThree = res.data.data;
            }
            // console.log(this.proList);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getBusiness() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "/Project/projectListThreeData";
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.proListThree = res.data.data;
        }
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      //   console.log(this.$store.state.token)
      this.form.validateFields((err, val) => {
        if (!err) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.resume +
            "Third_part/editThirdPart";
          let pramas = {
            id: this.editDetail.id,
            type: this.type,
            name: this.type == 2 ? "" : val.name,
            contact_name: val.contact_name,
            contact_phone: val.contact_phone,
            company_address: this.type == 2 ? "" : val.company_address,
            bank_name: val.bank_name,
            bank_branch: val.bank_branch,
            bank_no: val.bank_no,
            sign_status: val.sign_status,
            taxpayer: this.type == 2 ? "" : val.taxpayer,
            idcard: this.type == 1 ? "" : val.idcard,
            token: window.localStorage.getItem("xnwfPcToken"),
            project_ids:
              this.project_list == undefined
                ? JSON.stringify([])
                : JSON.stringify(this.project_list)
          };
          console.log(this.project_list.length);
          axios
            .post(url, pramas)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.$emit("hideInEdit", false);
                this.onReset();
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        }
      });
    },
    handleSelectChange(value) {
      //   console.log(value);
      //   this.form.setFieldsValue({
      //     note: `Hi, ${value === "male" ? "man" : "lady"}!`
      //   });
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 30px 4% 0;
}
</style>
<style lang="less">
.thirdPartyContainer {
  padding-bottom: 100px;
  .ant-form-item {
    margin-bottom: 14px;
  }
}
</style>
